import React from 'react';

import CheckCircleRoundedIcon from '@mui/icons-material/CheckCircleRounded';
import RestoreFromTrashRoundedIcon from '@mui/icons-material/RestoreFromTrashRounded';
import { SvgIconOwnProps } from '@infoods/lifebase-ui';

import { Status } from '../../../shared/components/ui-components';

type CoachStatusInfoProps = {
  isActive: boolean;
  iconSize: SvgIconOwnProps['fontSize'];
};

const CoachStatusInfo = ({ isActive, iconSize }: CoachStatusInfoProps) => {
  return isActive ? (
    <Status icon={<CheckCircleRoundedIcon fontSize={iconSize} color="success" />}>
      Active
    </Status>
  ) : (
    <Status icon={<RestoreFromTrashRoundedIcon fontSize={iconSize} color="tertiary" />}>
      Deactivated
    </Status>
  );
};

export { CoachStatusInfo };
